<template>
    <section class="section pt-1">
        <div class="columns is-centered">
            <div class="column is-6-desktop is-8-tablet">
                <div
                    class="box notification has-text-centered is-primary is-size-5 has-text-weight-bold"
                >
                    <p v-t="'Sessions.questions_completed'"></p>
                </div>
                <div class="notification has-text-centered has-background-white">
                    <div class="has-text-centered">
                        <figure class="is-inline-block is-75-width">
                            <img
                                src="@/assets/images/session_complete.png"
                                srcset="@/assets/images/session_complete@2x.png 2x, @/assets/images/session_complete@3x.png 3x"
                            />
                        </figure>
                        <p
                            class="title is-size-5 has-text-weight-bold py-6"
                            v-html="session.configuration.feedback ? session.configuration.feedback : $t('Sessions.end_of_game_default')"
                        >{{ session.configuration.feedback }}</p>
                    </div>
                    <hr class="has-background-grey-lighter" />
                    <p v-t="'Sessions.results_title'" class="has-text-centered pt-4"></p>
                    <nav class="level is-mobile pt-3">
                        <div class="level-item has-text-centered">
                            <session-end-resume-bubble
                                :title="$t('Sessions.ranking_position')"
                                :number="position"
                            />
                        </div>

                        <div class="level-item has-text-centered">
                            <session-end-resume-bubble
                                :title="$t('Sessions.score_achieved')"
                                :number="score"
                            />
                        </div>

                        <div class="level-item has-text-centered">
                            <session-end-resume-bubble
                                :title="$t('Sessions.question_count')"
                                :number="session.context.length"
                            />
                        </div>

                        <div class="level-item has-text-centered">
                            <session-end-resume-bubble
                                :title="$t('Sessions.question_hit_rate')"
                                :number="getPercent"
                            />
                        </div>
                    </nav>
                    <div class="buttons is-centered">
                        <router-link
                            v-t="'Sessions.go_to_session_details'"
                            :to="{
                                name: 'session-detail',
                                params: { _id: session._id },
                            }"
                            tag="a"
                            class="button is-link"
                        ></router-link>
                        <button
                            v-if="canResetSession"
                            v-t="'Buttons.reset_session'"
                            class="button is-primary is-outlined has-text-weight-bold"
                            @click="resetSession"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { getUserRankingPosition } from '@/services/API';
import SessionEndResumeBubble from '@/components/SessionEndResumeBubble';
export default {
    components: {
        SessionEndResumeBubble,
    },
    data() {
        return {
            position: undefined,
            score: 0,
        };
    },
    props: {
        rightQuestions: {
            type: Number,
            default: 0,
        },
        noAnswered: {
            type: Number,
            default: 0,
        },
        failedQuestions: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        session() {
            return this.$store.state.session || {};
        },
        canResetSession() {
            return this.session.allowsReset;
        },
        getPercent(){
            return Math.round((this.rightQuestions*100)/this.session.context.length);
        }
    },
    mounted() {
        getUserRankingPosition(this.session._id).then((e) => {
            this.position = e.data.position + 1;
            this.score = e.data.score;
        });
    },
    methods: {
        resetSession() {
            this.$store.dispatch('resetSession');
            this.$router.go();
        },
    },
};
</script>

<style scoped>
.is-75-width img {
    max-width: 75%;
    margin-left: 12%;
}
</style>
